import React, { useEffect, useState } from 'react'
import axios from "axios";
import SliderWrapper from 'jd-library/SliderWrapper'
import withRipple from 'jd-library/withRipple';
import FormRadio from 'jd-library/FormRadio'
import styles from "../add-edit-product/add-edit-product.scss";
import { useSelector } from 'react-redux';

const SizeChartSlider = (props) => {
    const session = useSelector(state => state.session)
    const [selected, setSelected] = useState(props.sizeChartId)
    const [showSizeChart, setShowSizeChart] = useState(false)

    const getSizeChartText = () => {
        for (let i = 0; i < sizeChartData.length; i++) {
            if (sizeChartData[i].id == selected) {
                return sizeChartData[i].sizeChartName;
            }
        }
    }


    const [sizeChartData, updateSizeChartData] = useState([])
    useEffect(() => {
        if (!sizeChartData.length) {
            axios.get('/vendorapis/size_chart/sizechart/fetchAllSizeChart?currentPage=1&supplierId=' + session.supplierId).then(data => {
                if (data.data.isSuccess == 'true' && data.data.page.results.length) {
                    updateSizeChartData(data.data.page.results);
                }
            })
        }
    }, [])

    const AddSizeChart = withRipple(props => {
        return (
            <div
                className={`${styles['sizechart-container']} ${props.rippleClass}`}
                onClick={() => {
                    setShowSizeChart(true);
                }}
                {...props.rippleHandler}
            >
                {selected ?
                    <div>
                        Size Chart <br />
                        <span className={styles["chart-name"]}>{getSizeChartText()}</span>
                    </div> :
                    <div>
                        Select Size Chart
                    </div>
                }
                <i className='icon-Next'></i>
                {props.renderRipple()}
            </div>
        )
    });

    return (
        <>
            {sizeChartData.length > 0 ? <AddSizeChart /> : null}
            {
                showSizeChart &&
                <SliderWrapper
                    header={{
                        heading: 'Select Size Chart'
                    }}
                    footer={{
                        btnProps: [{
                            children: 'Save',
                            clickHandler: () => {
                                props.onSelect(selected, getSizeChartText());
                                window.history.back();
                            },
                            size: "lg",
                        }]
                    }}
                    onHidden={e => setShowSizeChart(false)}
                >
                    {sizeChartData.map((data) => {
                        return (
                            <div
                                onClick={() => {
                                    setSelected(data.id)
                                }}
                            >
                                <FormRadio
                                    checked={selected == data.id}
                                    label={data.sizeChartName}
                                    style={{
                                        paddingLeft: '0.9375rem',
                                        marginBottom: '0px'
                                    }}
                                />
                                <div className={styles['fake-border']}></div>
                            </div>
                        )
                    })}
                </SliderWrapper>
            }
        </>

    )
}

export default SizeChartSlider